import { network } from 'services/network';

export const extractBattleCardToCsv = (params) => {
    const url = `api/bo/extractBattleCardToCsv?isCompact=${params.isCompact}`;

    return network.post(url, params.filter).then(() => {
        return true;
    });
};
